export const replacePathParams = (
  path: string,
  params: Record<string, string>
): string => {
  return path.replace(/:\w+/g, match => {
    const paramName = match.slice(1);
    return params[paramName] ?? match;
  });
};
